import type { NotifyPort } from '@/features/messages/domain/notify'
import type { ChatPort } from '../domain/chat'

const deleteMessage = async (
	port: ChatPort,
	messageId: string,
	scope: 'all' | 'self',
	notify: NotifyPort,
): Promise<boolean> => {
	try {
		await port.deleteMessage(messageId, scope)
		notify.success('chat.messageDeleted')
		return true
	} catch {
		notify.error('chat.messageDeleteFailed')
		return false
	}
}

export { deleteMessage }
